/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import company from './modules/company';
import createAccessProviderModule from '@produtos/store-access-provider';
import createSettingProviderModule from '@produtos/store-setting-provider';
import data from './modules/data';
import databaseLoopbackTransformer from '@i9box/vuelib/src/utils/datatable-loopback-transformer';
import metadata from './modules/metadata';
import transactions from './modules/transactions';
import users from './modules/users';
import vuelib from '@vuelib/store';
import * as jwtDecode from 'jwt-decode';
import SettingProviderStorage from '@produtos/store-setting-provider/src/storage';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    serviceName: 'Sync',
  },
  mutations: {
    setServiceName(state, value) {
      state.serviceName = value;
    },
  },
  actions: {
    async resolveServiceName({ commit }, { override } = {}) {
      if (override) {
        commit('setServiceName', override);
        return;
      }

      const storage = new SettingProviderStorage();
      const token = await storage.getCookieToken();

      if (!token?.id) return;

      const decoded = jwtDecode.jwtDecode(token.id);

      const service = decoded?.aud
        ?.map(v => v.startsWith('/') ? v.slice(1) : v)
        ?.find(v => v.startsWith('Sync'));

      if (service) {
        commit('setServiceName', service);
      }
    }
  },
  modules: {
    vuelib,
    app,
    auth,
    settingProvider: createSettingProviderModule(),
    accessProvider: createAccessProviderModule({
      domainAction: 'settingProvider/$setup',
      pinGetter: 'settingProvider/pin',
      fetchAllAdapter: databaseLoopbackTransformer,
    }),
    users,
    company,
    transactions,
    metadata,
    data,
  },
});

/* eslint-enable */

export default store;
